import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  FETCH_REQUESTS: 'FETCH_REQUESTS',
  SEARCH_REQUESTS: 'SEARCH_REQUESTS',
  CREATE_REQUEST: 'CREATE_REQUEST',
  UPDATE_REQUEST: 'UPDATE_REQUEST',
  UPDATE_REQUEST_MODAL: 'UPDATE_REQUEST_MODAL',
  DELETE_REQUEST: 'DELETE_REQUEST',
  ADD_REQUEST_MEETING_NOTE: 'ADD_REQUEST_MEETING_NOTE',
  REMOVE_REQUEST_MEETING_NOTE: 'REMOVE_REQUEST_MEETING_NOTE',
  ADD_REQUEST_COMMENT: 'ADD_REQUEST_COMMENT',
  REMOVE_REQUEST_COMMENT: 'REMOVE_REQUEST_COMMENT',
  ADD_REQUEST_TASK: 'ADD_REQUEST_TASK',
  REMOVE_REQUEST_TASK: 'REMOVE_REQUEST_TASK',
  REMOVE_REQUEST_LOG: 'REMOVE_REQUEST_LOG',
  SET_OPEN_MONTH: 'SET_OPEN_MONTH',
  SET_REQUEST_PAGE: 'SET_REQUEST_PAGE',
  RESET_REQUESTS_DATA: 'RESET_REQUESTS_DATA',
  RESET_SEARCH_DATA: 'RESET_SEARCH_DATA',
  SET_REQUEST_FILTER: 'SET_REQUEST_FILTER',
  RESET_REQUEST_FILTER: 'RESET_REQUEST_FILTER',
  SET_REQUEST_COLLAPSE_KEY: 'SET_REQUEST_COLLAPSE_KEY',
  CHANGE_REQUESTS_LAYOUT: 'CHANGE_REQUESTS_LAYOUT',
};

export const {
  fetchRequestsRequest,
  fetchRequestsSuccess,
  fetchRequestsFailure,
} = generateApiActions(types.FETCH_REQUESTS);

export const {
  searchRequestsRequest,
  searchRequestsSuccess,
  searchRequestsFailure,
} = generateApiActions(types.SEARCH_REQUESTS);

export const {
  createRequestRequest,
  createRequestSuccess,
  createRequestFailure,
} = generateApiActions(types.CREATE_REQUEST);

export const {
  updateRequestRequest,
  updateRequestSuccess,
  updateRequestFailure,
} = generateApiActions(types.UPDATE_REQUEST);

export const {
  updateRequestModalRequest,
  updateRequestModalSuccess,
  updateRequestModalFailure,
} = generateApiActions(types.UPDATE_REQUEST_MODAL);

export const {
  deleteRequestRequest,
  deleteRequestSuccess,
  deleteRequestFailure,
} = generateApiActions(types.DELETE_REQUEST);

export const addRequestMeetingNote = createAction(types.ADD_REQUEST_MEETING_NOTE);
export const removeRequestMeetingNote = createAction(types.REMOVE_REQUEST_MEETING_NOTE);

export const addRequestComment = createAction(types.ADD_REQUEST_COMMENT);
export const removeRequestComment = createAction(types.REMOVE_REQUEST_COMMENT);

export const addRequestTask = createAction(types.ADD_REQUEST_TASK);
export const removeRequestTask = createAction(types.REMOVE_REQUEST_TASK);

export const removeRequestLog = createAction(types.REMOVE_REQUEST_LOG);

export const setOpenMonth = createAction(types.SET_OPEN_MONTH);

export const setPage = createAction(types.SET_REQUEST_PAGE);

export const resetRequestsData = createAction(types.RESET_REQUESTS_DATA);
export const resetSearchDataRequests = createAction(types.RESET_SEARCH_DATA);

export const setFilter = createAction(types.SET_REQUEST_FILTER);
export const resetFilters = createAction(types.RESET_REQUEST_FILTER);

export const setCollapseKey = createAction(types.SET_REQUEST_COLLAPSE_KEY);

export const changeRequestsLayout = createAction(types.CHANGE_REQUESTS_LAYOUT);



// WEBPACK FOOTER //
// ./src/redux/actions/requests.js